import {
  Icon,
  IconButton,
  RHFTextField,
  UserRoleDropdown,
} from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { useCheckLimitReached } from '../../hooks/use-check-limit-reached';
import * as Styled from './styles';
import * as SX from './sx';
import type { MemberRowProps as Props } from './types';

export const MemberRow = memo(({ className, index, remove }: Props) => {
  const row = `members[${index}]`;
  const errorIcon = <Icon size={14} name="alert-fill" color="error.200" />;
  const { hasLimitReached } = useCheckLimitReached();

  return (
    <Styled.Wrapper className={classnames('MemberRow', className)}>
      <Stack width="100%">
        <RHFTextField
          variant={'outlined'}
          size={'small'}
          errorIcon={errorIcon}
          disabled={hasLimitReached}
          required
          name={`${row}.firstName`}
          label={'First Name'}
          FormHelperTextProps={{ sx: SX.textField }}
          helperText={' '}
          sx={SX.rhfInput}
          placeholder="Enter first name"
        />
      </Stack>
      <Stack width="100%">
        <RHFTextField
          variant={'outlined'}
          size={'small'}
          errorIcon={errorIcon}
          disabled={hasLimitReached}
          required
          label={'Last Name'}
          name={`${row}.lastName`}
          FormHelperTextProps={{ sx: SX.textField }}
          helperText={' '}
          sx={SX.rhfInput}
          placeholder="Enter last name"
        />
      </Stack>
      <Stack width="100%">
        <RHFTextField
          variant={'outlined'}
          size={'small'}
          errorIcon={errorIcon}
          disabled={hasLimitReached}
          required
          label={'Email'}
          type="email"
          name={`${row}.username`}
          FormHelperTextProps={{ sx: SX.textField }}
          helperText={' '}
          sx={SX.rhfInput}
          placeholder="Enter email address"
        />
      </Stack>
      <Stack width="100%">
        <UserRoleDropdown
          size={'medium'}
          name={`${row}.type`}
          label={'Role'}
          disabled={hasLimitReached}
          withoutOwner
          helperText={' '}
          FormHelperTextProps={{ sx: SX.textField }}
          placeholder="Choose a role"
        />
      </Stack>

      {remove && (
        <Stack>
          <IconButton
            icon="delete"
            color="error"
            size="small"
            onClick={() => remove(index)}
          />
        </Stack>
      )}
    </Styled.Wrapper>
  );
});

MemberRow.displayName = 'MemberRow';
